/**
 * Tanstack Query v5 хук для GET /v1/me. Server-state только через React
 * Query (патент проекта). Кэшируется на минуту.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchMe, type MeResponse } from './me.js';

export const ME_KEY = ['me'] as const;

export function useMe() {
  return useQuery<MeResponse>({
    queryKey: ME_KEY,
    queryFn: fetchMe,
    staleTime: 60_000,
  });
}
